define('app/models/UserPreference',['require','glu/model','config','glu/$'],function(require) {
	'use strict';

	var Model = require('glu/model'),
		config = require('config'),
		$ = require('glu/$');

	return Model.extend({

		idAttribute: 'name',

		initialize: function(attrs) {

			if (attrs && attrs.name) {
				this.attributes.name = attrs.name;
			}

			if (attrs && attrs.value) {
				this.attributes.value = attrs.value;
			}
		},

		url: function() {
			return config.apiRoot + 'service/userpreferences';
		},

		getName: function() {
			return this.get('name');
		},

		getValue: function() {
			return this.get('value');
		},

		setName: function(name) {
			this.set('name', name);
		},

		setValue: function(value) {
			this.set('value', value);
		},

		toJSON: function() {
			var serialized = {};
			serialized.name = this.getName();
			serialized.value = this.getValue();
			return serialized;
		},

		save: function() {
			return $.ajax(this.url(), {
				type: 'POST',
				contentType: 'application/json',
				data: JSON.stringify(this.toJSON())
			}).then(function(data) {
				return data;
			});
		}
	});
});

